export function jsonFormat(json: object): string {
  return JSON.stringify(json, null, 2)
}
